export const HALO_ICON_STATUS = {
  inactive: 'INACTIVE',
  active: 'ACTIVE',
  success: 'SUCCESS',
  danger: 'DANGER',
} as const;
